<ion-list>
    <ion-card class="card-grey">
        <ion-card-header>
            <ion-card-title>{{'charge.summary.title' | translate}}</ion-card-title>
        </ion-card-header>

        <ion-card-content>
            <ion-item class="chargeSummary-content">
                <i class="chargeSummary-content-icon icon-outlet"></i>
                <ion-label class="chargeSummary-content-label">
                    <p class="chargeSummary-content-label-title">
                        {{'plugType.' + newChargeContext.plugTypeChoice.plugType.name | translate}}
                        -
                        {{newChargeContext.chargePoint | stationChargePoint}}
                    </p>
                    <p class="chargeSummary-content-label-subcontent">
                        <span *ngIf="newChargeContext.chargePoint?.maxPowerInW">{{'chargePoint.maxPower' | translate}}</span>
                        {{newChargeContext.chargePoint?.maxPowerInW | powerMaxInWToKw}}
                    </p>
                </ion-label>
            </ion-item>

            <ion-item *ngIf="newChargeContext.hasReservation()"
                      class="chargeSummary-content">
                <ion-icon class="chargeSummary-content-icon" name="time-outline"></ion-icon>
                <ion-label class="chargeSummary-content-label">
                    <p class="chargeSummary-content-label-title">{{'charge.reservationChoice.title' | translate}}</p>
                    <p *ngIf="newChargeContext.isOTP() else reservationPrice"  class="chargeSummary-content-label-subcontent chargeSummary-expirationDate">
                        {{'reservation.until' | translate:{expirationDate: newChargeContext?.mediaSummary?.expirationDate | date:'medium'} }}
                    </p>
                    <ng-template #reservationPrice>
                        <p class="chargeSummary-content-label-subcontent">
                            {{newChargeContext?.reservation?.durationInMinutes | duration :{report: true, minutes: true, seconds: false, entryUnit: 'm'} }}
                            -
                            {{newChargeContext?.reservation?.price?.priceWithVAT | currency:undefined: newChargeContext?.reservation?.price?.currencyUnit}}
                        </p>
                    </ng-template>
                </ion-label>
            </ion-item>

            <ion-item *ngIf="!newChargeContext.isOTP()"
                      class="chargeSummary-content">
                <ion-icon class="chargeSummary-content-icon" name="card"></ion-icon>
                <ion-label class="chargeSummary-content-label">
                    <p class="chargeSummary-content-label-title">{{newChargeContext.mediaSummary?.visual.name}}</p>
                    <p class="chargeSummary-content-label-subcontent" *ngIf="newChargeContext.mediaSummary?.alias">
                        {{newChargeContext.mediaSummary?.alias}}
                    </p>
                    <p class="chargeSummary-content-label-subcontent">{{newChargeContext.mediaSummary?.name}}</p>
                </ion-label>
            </ion-item>

            <ion-item *ngIf="newChargeContext.isOTP()" class="chargeSummary-content">
                <ion-icon class="chargeSummary-content-icon" name="card"></ion-icon>
                <ion-label class="chargeSummary-content-label">
                    <p class="chargeSummary-content-label-title">{{'charge.summary.otpCode' | translate}}</p>
                    <p class="chargeSummary-content-label-subcontent">{{newChargeContext.mediaSummary?.visual.code}}</p>
                </ion-label>
            </ion-item>
        </ion-card-content>
    </ion-card>
</ion-list>

<ion-list *ngIf="hasPricingInfo || ghostPricing"
          [class.ghost]="ghostPricing">
    <ion-card class="card-grey">
        <ion-card-header>
            <ion-card-title class="medium-ghost-size">
                <span class="ghost-hidden">{{'charge.summary.prices' | translate}}</span>
            </ion-card-title>
        </ion-card-header>

        <ion-card-content>
            <!-- Charge rate -->
            <ion-item class="chargeSummary-content chargeSummary-price">
                <ion-icon class="chargeSummary-content-icon" name="battery-charging"></ion-icon>
                <ion-label class="chargeSummary-content-label">
                    <p class="chargeSummary-content-label-title medium-ghost-size">
                        <span class="ghost-hidden">{{'charge.mediaChoice.chargeRate' | translate}}</span>
                    </p>
                    <p class="chargeSummary-content-label-subcontent">
                        <pricing-context-formatter [pricingContext]="pricingContext"
                                                   [ghostMode]="ghostPricing">
                        </pricing-context-formatter>
                    </p>
                </ion-label>
            </ion-item>

            <!-- Next development: place here reservation or other rates -->
        </ion-card-content>
    </ion-card>
</ion-list>



